import * as Yup from 'yup';
import { validationMessages, WEB_URL_REGEX } from '../../../../../utils/Constants';

export const validatePeDocument = (val = '') => {
  const { length } = val.toString();
  return (length >= 8 && length <= 9) || length === 12;
};

export const validationSchemaPE_LegalRepresentative = (t) =>
  Yup.object().shape({
    fullName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    email: Yup.string().email(t('validationEmailSpanish')).required(t(validationMessages.requiredSpanish)),
    rfc: Yup.string().required(t('numericValidationRequiredSpanish')).test('len', 'Debe ser de 8 hasta 9 números, o de 12 números', validatePeDocument),
    fullAddress: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
  });
export const validationSchemaPE_Company = (t) =>
  Yup.object().shape({
    commercialName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    legalName: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(40, t(validationMessages.maxLength, { amount: 40 })),
    rfc: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(11, t(validationMessages.minLength, { amount: 11 }))
      .max(11, t(validationMessages.maxLength, { amount: 11 })),
    fullAddress: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
    city: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(2, t(validationMessages.minLength, { amount: 2 }))
      .max(128, t(validationMessages.maxLength, { amount: 128 })),
    country: Yup.string().required(t(validationMessages.requiredSpanish)),
    web: Yup.string().required(t(validationMessages.requiredSpanish)).matches(WEB_URL_REGEX, t('validationUrl')),
    proofOfTaxSituation: Yup.mixed().required(t(validationMessages.requiredSpanish)),
    zipCode: Yup.string().required(t(validationMessages.requiredSpanish)),
    bank: Yup.string().required(t(validationMessages.requiredSpanish)),
    clabe: Yup.string().required(t(validationMessages.requiredSpanish)),
    accountCode: Yup.string()
      .required(t(validationMessages.requiredSpanish))
      .min(20, t(validationMessages.minLength, { amount: 20 }))
      .max(20, t(validationMessages.maxLength, { amount: 20 })),
  });
